import {Tooltip} from "@mui/material";

export function replaceMergeTag(replaceText, mergeTag, replaceWith) {
    return replaceText.replace(mergeTag, replaceWith);
}

export function showEllipsis(text, length) {
    return (
        <Tooltip title={text} placement="top">
            <p>{text.substring(0, length - 3)}...</p>
        </Tooltip>
    )
}

export const priceFormatter = (price, { useThousands = true, decimals = 2 } = {}) => {
    return new Intl.NumberFormat('de-DE', {
        minimumFractionDigits: decimals,
        maximumFractionDigits: decimals,
        useGrouping: useThousands,
    }).format(price);
};

export function flattenEmptyKey(obj) {
    if (obj === null || typeof obj !== 'object') return obj;

    // Create a shallow copy to avoid mutating the original
    const result = { ...obj };

    // If there's an empty-string key and its value is an object
    if (result.hasOwnProperty('') && typeof result[''] === 'object' && result[''] !== null) {
        Object.assign(result, result['']);
        delete result[''];
    }

    return result;
}